import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  useMemo,
} from "react";
import AuthContext, { AuthService } from "./AuthContext";
import ApiContext from "api";
import { setUpUnauthorizedInterceptor } from "api/ApiClient";
import { toast } from "react-toastify";
import ClienteService from "services/cliente";

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => AuthService.getTokenLocalStorage());
  const [userCpf, setUserCpf] = useState(() =>
    AuthService.getUserCpfLocalStorage()
  );
  const [isAdm, setIsAdmState] = useState(() =>
    AuthService.getAdmLocalStorage()
  );

  function setIsAdm(value) {
    AuthService.setIsAdmLocalStorage(value);
    setIsAdmState(value);
  }

  const { ConsigazApi } = useContext(ApiContext);

  const login = useCallback(
    async ({ cpfCnpj, password, type }) => {
      try {
        const response = await ConsigazApi.generatesToken({
          cpfCnpj,
          password,
          type,
        });

        const newToken = response.token[0].token;

        AuthService.setTokenLocalStorage(newToken);
        AuthService.setUserCpfLocalStorage(cpfCnpj);

        setToken(newToken);
        setUserCpf(cpfCnpj);

        return true;
      } catch (error) {
        toast.error(error ?? "");
        return false;
      }
    },
    [ConsigazApi]
  );

  const logout = useCallback(() => {
    AuthService.removeTokenLocalStorage();

    AuthService.removeUserCpfLocalStorage();
    AuthService.removeIndustrialLinkedUnits();

    setToken(null);
    setIsAdm(false);
    setUserCpf(null);
    ClienteService.logout();
  }, []);

  useEffect(() => {
    setUpUnauthorizedInterceptor(logout);
  }, [logout]);

  const value = useMemo(
    () => ({
      token,
      isAuthenticated: Boolean(token),
      login,
      userCpf,
      logout,
      isAdm,
      setIsAdm,
    }),
    [token, login, userCpf, logout, isAdm]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
